import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import easeInLeftGif from '../../../assets/images/transitions/easeInLeft.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_OUT_LEFT = 'easeOutLeft';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeOutLeftPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_OUT_LEFT,

  // A human friendly name for the preset.
  humanName: 'Ease Out & Rotate to Left',

  // A preview of the transition.
  gif: easeInLeftGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      time: {
        start: 'end.-1000',
        end: 'end.0'
      },
      easing: EASINGS.easeInPower3,
      values: [
        'position.left',
        'off.left'
      ],
      immediateRender: false
    },
    'transform.rotate': {
      time: {
        start: 'end.-1000',
        end: 'end.0'
      },
      easing: EASINGS.easeInPower3,
      values: [
        '0',
        '90'
      ],
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_OUT_LEFT,
    options: {},
  },
};

easeOutLeftPresetDetails.template.options = lodash.cloneDeep(easeOutLeftPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_OUT_LEFT;

// This defines the value of the presets object.
export default easeOutLeftPresetDetails;
